<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>

  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">identifier</th>
                <th class="table-heading-text text-center">type</th>
                <th class="table-heading-text text-right">valuation</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="asset in otherAssets.other_assets" :key="asset.id" @click="showEditModal(asset)">
                <td class="table-content-text text-left">{{ asset.identifier }}</td>
                <td class="table-content-text text-center">{{ asset.is_financial ? 'financial' : 'non-financial' }}</td>
                <td class="table-content-text text-right">{{ asset.valuation.toLocaleString() }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td></td>
                <td class="table-heading-text text-right">{{ Number(otherAssets.total_valuation).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- Modals-->
  <OtherAssetModalPopup :show="showModal" @close="showModal = false"></OtherAssetModalPopup> <!-- add a new record -->
  <OtherAssetEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></OtherAssetEditModalPopup> <!--edit a record -->

</template>

<script>
import axios from 'axios';
import OtherAssetModalPopup from './modals/OtherAssetNewModalPopup.vue';
import OtherAssetEditModalPopup from './modals/OtherAssetEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    OtherAssetModalPopup,
    OtherAssetEditModalPopup
  },
  data() {
    return {
      otherAssets: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {}
    };
  },
  async created() {
    this.getOtherAssets();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'other assets',
          disabled: true,
          href: ''
        },
      ];
    },

  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
     this.selectedRow=row;
     this.showEditModalToggle = true;
    },
    async getOtherAssets(){
      try {
      const response  = await axios.get("/otherassets/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.otherAssets = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load other assets' });
      }
    }
  }
};
</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}


</style>
